import { http } from '../../config/axios'

const deleteUserDuploFator = (): Promise<void> => {
  return http
    .delete('api/user/duplo-fator')
    .then(() => {
      return
    })
    .catch((error) => {
      console.error('Erro deleteUserDuploFator', error)
      throw Error(error.response?.data)
    })
}

export default deleteUserDuploFator
